<!--
 * @Descripttion: 
 * @version: 
 * @Author: geory
 * @Date: 2023-08-25 10:32:01
 * @LastEditors: geory
 * @LastEditTime: 2025-12-23 15:25:59
-->
<template>
  <div @contextmenu.prevent.stop>
    <div
      class="cover"
      :style="{ width: pageWidth, height: pageHeight }"
      @click="hideMenu"
    >
    <div
      class="container"
      :style="{ top: adjustedTop + 'px', left: adjustedLeft + 'px' }"
    >
        <!-- <div class="munucell borderNone" @click="edit">编辑</div>
        <div class="munucell" @click="remove">删除</div> -->
        <div
          v-for="(cell, idx) in cellList"
          :key="'menuItem' + idx"
          :class="idx == 0 ? 'munucell borderNone' : 'munucell'"
          @click="cellClick(idx)"
        >
          {{ cell.label }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//话术右键菜单
export default {
  props: ["menuY", "menuX", "cellList"],
  data() {
    return {
      pageHeight: document.documentElement.clientHeight + "px",
      pageWidth: document.documentElement.clientWidth + "px",
    };
  },
  components: {},
  computed: {
    adjustedTop() {
      // 每个菜单项高度32px + 容器border 2px，估算菜单总高度
      const menuHeight = this.cellList.length * 32 + 2;
      const viewportHeight = document.documentElement.clientHeight;
      if (this.menuY + menuHeight > viewportHeight) {
        // 超出底部，翻转到点击位置上方
        return Math.max(0, this.menuY - menuHeight);
      }
      return this.menuY;
    },
    adjustedLeft() {
      const menuWidth = 96;
      const viewportWidth = document.documentElement.clientWidth;
      if (this.menuX + menuWidth > viewportWidth) {
        // 超出右侧，翻转到左侧
        return Math.max(0, this.menuX - menuWidth);
      }
      return this.menuX;
    },
  },
  methods: {
    cellClick(idx) {
      this.$emit("cellClick", idx);
      this.hideMenu();
    },
    edit() {
      this.$emit("edit");
      this.hideMenu();
    },
    remove() {
      this.$emit("remove");
      this.hideMenu();
    },
    hideMenu() {
      this.$emit("hideMenu");
    },
    autoSend() {
      this.$emit("autoSend");
      this.hideMenu();
    },
  },
  async mounted() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.cover {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 9999;
}

.container {
  width: 96px;
  background-color: #f0f0f0;
  border: 1px solid #e5e5e5;
  position: absolute;
  z-index: 99999;
  border-radius: 8px;
}

.munucell {
  width: 100%;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: 1px solid #e5e5e5;
  color: #3c3c3c;
}

.borderNone {
  border: none;
}
</style>
